import { combineReducers } from "redux";

// reducers
import appDetails from "store/reducers/app";

import loginDetails from "store/reducers/login";

import toasterDetails from "store/reducers/toaster";

import confirmDialogDetails from "store/reducers/confirmDialog";

import modalPopupDetails from "store/reducers/modalPopup";

import dropdownDetails from "store/reducers/dropdown";

import hfnDsUiDetails from "store/reducers/hfnDsComponentsReducer";

const rootReducer = combineReducers({
  appDetails,
  loginDetails,
  toast: toasterDetails,
  confirmDialogDetails,
  modalPopupDetails,
  dropdownDetails,
  hfnDsUiDetails
});

export default rootReducer;
